// Bridges the bundled React build to the global names the prototype's design
// files expect. The original files were written against the CDN UMD build,
// where `React` and `ReactDOM` were globals — they reference React.useState,
// React.useRef, ReactDOM.createRoot, etc. directly. Setting them on window
// here lets every design file run unchanged.
import * as React from 'react';
import * as ReactDOMClient from 'react-dom/client';

window.React = React;
window.ReactDOM = ReactDOMClient;
